module.exports = __webpack_public_path__ + "static/media/menu.eab81399.jpg";